import { get } from 'lodash';
import { connect } from 'react-redux';
import { compose, withState, withPropsOnChange, withProps } from 'recompose';

import { resetDirty } from '../metrics/actions';
import { getRefundsAndTransactions } from './selectors';
import { getBarberUser } from '../../../auth/selectors';
import { getBarberFilterForApi } from '../metrics/selectors';
import withNewDesignStyles from '../../../common/hoc/withNewDesignStyles';
import { getEndDateForAPI, getStartDateForAPI } from '../filters/selectors';
import { getBrandFiltersForApi, getServiceCategoryFilterForApi } from '../selectors';

const SharedContainer = compose(
  withNewDesignStyles,
  connect(
    state => ({
      shop: state.auth.shop,
      barber: getBarberUser(state),
      isLoading: !!state.loadingBar,
      items: getRefundsAndTransactions(state),
      filters: {
        fromDate: getStartDateForAPI(state),
        toDate: getEndDateForAPI(state),
        barberFilter: getBarberFilterForApi(state),
        serviceCategories: getServiceCategoryFilterForApi(state),
        productBrands: getBrandFiltersForApi(state),
      },
    }),
    { resetDirty },
  ),
  withPropsOnChange(
    ['open'],
    (props) => {
      if (props.open) {
        const barberId = get(props.barber, 'id');
        const {
          fromDate: start,
          toDate: end,
          barberFilter,
          serviceCategories,
          productBrands,
        } = props.filters;

        props.fetchReport(props.shop, barberId, start, end, barberFilter, serviceCategories, productBrands, props.kind)
          .then(props.resetDirty);
      }
    }
  ),
  withProps((props) => {
    if (props.kind) {
      return {
        filters: {
          ...props.filters,
          type: props.kind,
        },
      };
    }

    return {};
  }),
  withState('expanded', 'setExpanded', {}),
);

export default SharedContainer;
